const actions = {
    GET_COMPRAS_REQUEST: 'GET_COMPRAS_REQUEST',
    CREATE_COMPRA_REQUEST: 'CREATE_COMPRA_REQUEST',
    EDIT_COMPRA_REQUEST: 'EDIT_COMPRA_REQUEST',
    DELETE_COMPRA_REQUEST: 'DELETE_COMPRA_REQUEST',

    GET_COMPRAS_SUCCESS: 'GET_COMPRAS_SUCCESS',
    CREATE_COMPRA_SUCCESS: 'CREATE_COMPRA_SUCCESS',
    EDIT_COMPRA_SUCCESS: 'EDIT_COMPRA_SUCCESS',
    DELETE_COMPRA_SUCCESS: 'DELETE_COMPRA_SUCCESS',
    PASS_TO_PAY: 'PASS_TO_PAY',

    IMPORTAR_COMPRAS: 'IMPORTAR_COMPRAS',

    getCompras: (query) => ({ type: actions.GET_COMPRAS_REQUEST, query }),
    createCompra: (data, history) => ({
        type: actions.CREATE_COMPRA_REQUEST,
        data,
        history
    }),
    importarCompras: (data) => ({
        type: actions.IMPORTAR_COMPRAS,
        data,
    }),
    editCompra: data => ({
        type: actions.EDIT_COMPRA_REQUEST,
        payload: data
    }),
    deleteCompra: id => ({
        type: actions.DELETE_COMPRA_REQUEST,
        payload: id
    }),
    passToPay: compra => ({type: actions.PASS_TO_PAY, payload: compra })

};
export default actions;